import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function RarityReportHero() {
  return (
    <section className="relative py-24 bg-black border-t border-[#9333EA]/20">
      <div className="absolute inset-0 bg-[url('/grid.svg')] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))] opacity-50" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#9333EA]">
                xChain Rarity Report
              </h2>
              <p className="mt-2 text-sm text-[#9333EA]/60">v1.0a</p>
            </div>
            
            <p className="text-lg text-nft-muted">
              Check the rarity of the entire collection across all chains. All rarities are based on complete collection.
            </p>

            <ul className="text-left space-y-6">
              {[
                "Trait distribution rarity",
                "Trait combinations",
                "Search by ID",
                "Search by trait value",
                "Global comparison of rarity across multiple chains"
              ].map((feature, index) => (
                <li key={index} className="flex items-center space-x-4 text-nft-muted">
                  <span className="text-[#9333EA] text-2xl">•</span>
                  <span className="text-lg">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="pt-8">
              <Link to="/report">
                <Button 
                  className="bg-[#9333EA] hover:bg-[#9333EA]/80 text-white px-8 py-6 text-lg"
                >
                  View Rarity Report
                </Button>
              </Link>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="relative">
            <div className="rounded-lg border-2 border-[#9333EA]/20">
              <img 
                src="/images/stats-preview.png" 
                alt="Rarity Report Preview" 
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 